
export default {
  name: "FormSelectAuth",
  props: {
    height: {
      type: Number,
      required: false,
      default: 50
    },
    width: {
      type: Number,
      required: false,

    },
    items: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  components: {},
  data() {
    return {
      isOpen: false,
      isChosen: false,
      chosenId: '',
    }
  },
  computed: {},

  methods: {
    openToggle() {
      this.isOpen = !this.isOpen

    },
    makeChoice(id, index, price, name) {
      this.$emit('makeChoice',id, price)
      this.openToggle
      this.isChosen = true
      this.chosenId = name

    }
  },

  mounted() {
    if (this.$route.query.plan && +this.$route.query.plan !=1) {
      let tempPlan = this.items.find(item => item.id === +this.$route.query.plan)
      this.chosenId = tempPlan.name;

    }
  }
}
